import firstStep, { secondStep } from './steps';

export default async function inboundSignin(realm, gotoUrl) {
  const encodedGoto = encodeURIComponent(gotoUrl);
  try {
    const { authId, redirectCallback } = await firstStep(encodedGoto, realm);
    return { authId, redirectCallback };
  } catch (err) {
    return null;
  }
}

export async function secondStepInit(realm, authId) {
  try {
    const { successUrl, tokenId } = await secondStep(realm, authId);
    return { successUrl, tokenId };
  } catch (err) {
    return null;
  }
}
